<template>
    <v-select :value="value"
              :dense="dense"
              :disabled="disabled"
              :items="items"
              item-text="userName"
              item-value="id"
              attach
              :chips="chips"
              :label="label"
              @change="change"
              @input="update"
              :multiple="multiple"
              :menu-props="{ auto: true, botton: true, offsetY: true }">
    </v-select>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'selectUser',
        props: ['value', 'disabled', 'dense', 'multiple','chips','label'],
        data: function () {
            return {};
        },

        computed: {
            ...mapState('user', ['items'])
        },
        methods: {
            ...mapActions('user', ['getAll']),

            update(newValue) {
                this.$emit('input', newValue);
            },

            change(value) {
                this.$emit('change', value);
            },

        },
        mounted() {
            this.getAll();
        },
    };
</script>
